module.exports = __webpack_public_path__ + "static/media/up_caret_arrow.4792e130.svg";